import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import config from "./config";
import "./assets/scss/style.scss";
import { store, persister } from "./store";

function startApp(newVersionAvailable = false) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persister}>
        <BrowserRouter basename={config.basename}>
          <App newVersionAvailable={newVersionAvailable} />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

fetch(process.env.PUBLIC_URL + "/meta.json?time=" + Date.now(), { cache: "no-store" })
  .then((res) => res.json())
  .then((data) => {
    const currentVersion = data.version;
    const storedVersion = localStorage.getItem("app_version");

    if (storedVersion && storedVersion !== currentVersion) {
      startApp(true);
    } else {
      localStorage.setItem("app_version", currentVersion);
      startApp(false);
    }
  })
  .catch((err) => {
    console.warn("Version check failed:", err);
    startApp(false);
  });

setInterval(() => {
  fetch(process.env.PUBLIC_URL + "/meta.json?time=" + Date.now(), { cache: "no-store" })
    .then((res) => res.json())
    .then((data) => {
      const storedVersion = localStorage.getItem("app_version");
      if (storedVersion && storedVersion !== data.version) {
        localStorage.setItem("new_version_detected", "true");
      }
    })
    .catch(() => {});
}, 30000);